module.exports = __webpack_public_path__ + "static/media/straven_6.c4d6ec30.jpg";